import { render, staticRenderFns } from "./CommentWords.vue?vue&type=template&id=325a34e7&scoped=true"
import script from "./CommentWords.vue?vue&type=script&lang=js"
export * from "./CommentWords.vue?vue&type=script&lang=js"
import style0 from "./CommentWords.vue?vue&type=style&index=0&id=325a34e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a34e7",
  null
  
)

export default component.exports